import { render, staticRenderFns } from "./calyrafit-best-saller.vue?vue&type=template&id=0b23a819&scoped=true&"
import script from "./calyrafit-best-saller.vue?vue&type=script&lang=js&"
export * from "./calyrafit-best-saller.vue?vue&type=script&lang=js&"
import style0 from "./calyrafit-best-saller.vue?vue&type=style&index=0&id=0b23a819&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b23a819",
  null
  
)

export default component.exports